// icons
import { MdCalendarToday, MdCalendarMonth, MdEvent } from "react-icons/md";

const agendaServicios = {
  id: 'agenda-servicios-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'agenda-servicios',
      title: "Agenda de Servicios",
      type: 'collapse',
      icon: MdEvent,
      children: [
        {
          id: 'agenda-diaria',
          title: "Agenda Diaria",
          type: 'item',
          breadcrumbs: false,
          icon: MdCalendarToday,
          url: '/agenda-servicios/agenda-diaria'
        },
        {
          id: 'calendario-mensual',
          title: "Calendario Mensual",
          type: 'item',
          breadcrumbs: false,
          icon: MdCalendarMonth,
          url: '/agenda-servicios/calendario-mensual'
        }
      ]
    }
  ]
};

export default agendaServicios;
